'use strict';

(function () {
  angular
    .module('specsguardApp')
    .directive('sgElementCreatedItem', sgElementLogItem);

  sgElementLogItem.$inject = ['sgElementItems'];

  function sgElementLogItem (sgElementItems) {
    return {
      templateUrl: 'app-legacy/components/sg-element-items/sg-element-created-item.tmpl.html',
      transclude: true,
      scope: {
        item: '=',
        labels: '=',
        setFullName: '&'
      },
      link: function ($scope) {
        $scope.fullName = (item) => sgElementItems.setFullName(item);
        $scope.getLabelKey = (text) => {
          switch (text) {
            case 'Project element created':
              return $scope.labels.getLabel('projectspecificationcreated');
            case 'Project element copied from template element':
              return $scope.labels.getLabel('projectspecificationcopiedfromspecification');
            case 'Project element copied from source project':
              return $scope.labels.getLabel('projectspecificationcopiedfromsourceproject');
            case 'Template element created':
              return $scope.labels.getLabel('templatespecificationcreated');
            case 'Template element copied from template element':
              return $scope.labels.getLabel('templatespecificationcopiedfromspecification');
            default:
              return text;
          }
        };
      }
    };
  }
})();
